const toPercent = (num: number | string, decimal = 3) => {
  return (Number(num) * 100).toFixed(decimal) + '%';
};

export default toPercent;
